import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { AccountingRange } from 'src/features/accountingRanges/utils/types';
import { useCreateAccountingRange } from 'src/features/accountingRanges/api/useCreateAccountingRange';
import { LIST_ACCOUNTING_RANGES_RESOURCE } from 'src/features/accountingRanges/api/useListAccountingRanges';
import { accountingRangesMessages } from 'src/features/accountingRanges/utils/messages';
import AccountingRangeFormModal from 'src/features/accountingRanges/components/forms/AccountingRangeFormModal';

interface CreateAccountingRangeFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedAccountingRange?: AccountingRange;
    children?: React.ReactNode;
}

function CreateAccountingRangeFormModal<TData>({ className, semantics }: CreateAccountingRangeFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateAccountingRange({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ACCOUNTING_RANGES_RESOURCE] });
            toast({
                title: formatMessage(accountingRangesMessages.createAccountingRangeSuccess),
                description: formatMessage(accountingRangesMessages.createAccountingRangeSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <AccountingRangeFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(accountingRangesMessages.addAccountingRangeSubtitle)}
        />
    );
}

export default CreateAccountingRangeFormModal;
